export default __webpack_public_path__ + "eidv.png";